import {NullAsDefault, renderIfElse} from "../../../Shared";
import classNames from "classnames";
import React from "react"
import useTranslate from "../../../../modules/local/useTranslate";

export const SubClassTags = ({items = [], selected, setSelected = NullAsDefault, label}) => {
    const t = useTranslate();

    if (!items.filter(e => !!e).length) return null

    return (
        <div className="flex flex-col gap-1.5">
            {label && (
                <span className="text-xs text-color-400 italic">{label}</span>
            )}
            <div className="flex flex-wrap gap-1.5">
                {[...items.filter(e => !!e)].sort((a, b) => a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'})).map((e, i) => (
                    <span
                        key={i}
                        className={classNames(
                            "px-3 py-1 text-xs font-medium rounded-full border transition-colors cursor-pointer select-none",
                            selected === e
                                ? "bg-indigo-600 border-indigo-600 text-white"
                                : "border-color-200 text-color-300 hover:border-indigo-400 hover:text-indigo-500"
                        )}
                        onClick={() => setSelected(selected === e ? null : e)}>
                        {renderIfElse(e, e, t('not yet classified'))}
                    </span>
                ))}
            </div>
        </div>
    )
}